(function () {

    'use strict';

    var ngModule = angular.module('breakmarkApp');

    ngModule.controller('StoreCtrl', function TodoCtrl($scope, $state, $Stores, SplashModalService) {
    	$scope.stores = $Stores.all();

        $scope.add = function() {
            var store = {
                status: 'open'
            };

            $state.go('store-detail');

            // SplashModalService.open({
            //     btnText: 'Close',
            //     title: 'Would you like to add a Store?',
            //     message: 'Use this to add a new store',
            //     templateUrl: 'directives/storeList/modal.html',
            //     edit: false,
            //     store: store,
            //     submit: function() {
            //         /* Add to the collection. */
            //         console.log('ssss', store);
			// 	    $Stores.add(store);
			// 	}
            // });
        };
    });

})();
